import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";
import MaintenanceGate from "./components/MaintenanceGate";
import HotTopicBanner from "./components/HotTopicBanner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import News from "./pages/News";
import ArticleDetail from "./pages/ArticleDetail";
import Historie from "./pages/Historie";
import Events from "./pages/Events";
import Rares from "./pages/Rares";
import Team from "./pages/Team";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import EventDetail from "./pages/EventDetail";
import Badges from "./pages/Badges";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import UserLogin from "./pages/UserLogin";
import UserRegister from "./pages/UserRegister";
import Verify from "./pages/Verify";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import MyStories from "./pages/MyStories";
import Furniture from "./pages/Furniture";
import Sammlung from "./pages/Sammlung";
import Leaderboard from "./pages/Leaderboard";
import Shop from "./pages/Shop";
import About from "./pages/About";
import UserProfile from "./pages/UserProfile";
import Jobs from "./pages/Jobs";
import JobDetail from "./pages/JobDetail";
import Support from "./pages/Support";
import MyApplications from "./pages/MyApplications";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App scanline-bg min-h-screen">
      <AuthProvider>
        <ThemeProvider>
        <BrowserRouter>
          <MaintenanceGate>
            <HotTopicBanner />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<ArticleDetail />} />
              <Route path="/historie" element={<Historie />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/rares" element={<Rares />} />
              <Route path="/projekte" element={<Projects />} />
              <Route path="/projekte/:slug" element={<ProjectDetail />} />
              <Route path="/badges" element={<Badges />} />
              <Route path="/moebel" element={<Furniture />} />
              <Route path="/sammlung" element={<Sammlung />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/about" element={<About />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/jobs/:id" element={<JobDetail />} />
              <Route path="/support" element={<Support />} />
              <Route path="/meine-bewerbungen" element={<MyApplications />} />
              <Route path="/ueber-uns" element={<About />} />
              <Route path="/u/:name" element={<UserProfile />} />
              <Route path="/profil/:name" element={<UserProfile />} />
              <Route path="/team" element={<Team />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/schreibtisch" element={<Navigate to="/admin" replace />} />
              <Route path="/meine-stories" element={<MyStories />} />
              {/* User-Auth */}
              <Route path="/login" element={<UserLogin />} />
              <Route path="/registrieren" element={<UserRegister />} />
              <Route path="/verifizieren" element={<Verify />} />
              <Route path="/profil" element={<Verify />} />
              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Footer />
            <Toaster />
          </MaintenanceGate>
        </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
